import { render, staticRenderFns } from "./MoneyUpdate.vue?vue&type=template&id=3d87d1b6&"
import script from "./MoneyUpdate.vue?vue&type=script&lang=js&"
export * from "./MoneyUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports